import script from "./PerformerProjectFormStep3.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectFormStep3.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectFormStep3.vue?vue&type=style&index=0&id=88154fc6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88154fc6"]])

export default __exports__